import * as React from 'react';
import {DialogOverlay, DialogContent} from '@reach/dialog';
import cl from 'classnames';

import s from './Dialog.module.css';

export default function Dialog({children, isOpen, onDismiss, overlayClassName, className}) {
  return (
    <DialogOverlay isOpen={isOpen} className={cl(s.Overlay, overlayClassName)}>
      <DialogContent isOpen={isOpen} onDismiss={onDismiss} className={cl(s.Dialog, className)}>
        {children}
      </DialogContent>
    </DialogOverlay>
  );
}
